import React from 'react';

import styled from 'styled-components';

import { FormattedMessage } from '@techstyle/react-intl';

import { MembershipFeatureItem } from './MembershipFeatureItem';

const List = styled.ul`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-self: flex-start;
  flex-wrap: wrap;

  gap: 8px 0px;
`;

export const MembershipFeaturesList = () => {
  return (
    <List>
      <MembershipFeatureItem
        iconSrc="/static/images/membership_modal/save-up-to.svg"
        alt="Save Up to 25% off"
      >
        <FormattedMessage
          defaultMessage="Always enjoy {saveUpTo} full-price styles"
          id="global_checkout.shop_emp_tip_p5"
          values={{
            saveUpTo: (
              <b>
                <FormattedMessage
                  defaultMessage="up to 25% off"
                  id="global_checkout.membership_modal_save_up_to"
                />
              </b>
            ),
          }}
        />
      </MembershipFeatureItem>
      <MembershipFeatureItem
        iconSrc="/static/images/membership_modal/free-shipping.svg"
        alt="Free shipping"
      >
        <FormattedMessage
          defaultMessage="Free shipping on all $59.95+ orders"
          id="global_checkout.membership_modal_free_shipping_on_all"
        />
      </MembershipFeatureItem>

      <MembershipFeatureItem
        iconSrc="/static/images/membership_modal/membership-offers.svg"
        alt="Exclusive sales and offers"
      >
        <FormattedMessage
          defaultMessage="Exclusive {salesAndOffers}"
          id="global_checkout.membership_modal_exclusive_sales_offers"
          values={{
            salesAndOffers: (
              <b>
                <FormattedMessage
                  defaultMessage="sales and offers"
                  id="global_checkout.membership_modal_sales_offers"
                />
              </b>
            ),
          }}
        />
      </MembershipFeatureItem>

      <MembershipFeatureItem
        iconSrc="/static/images/membership_modal/90-day-fit.svg"
        alt="90-Day Fit Guarantee"
      >
        <FormattedMessage
          defaultMessage="{fitGuarantee} on returns and exchanges"
          id="global_checkout.membership_modal_returns_and_exchanges"
          values={{
            fitGuarantee: (
              <b>
                <FormattedMessage
                  defaultMessage="90-Day Fit Guarantee"
                  id="global_checkout.membership_modal_fit_guarantee"
                />
              </b>
            ),
          }}
        />
      </MembershipFeatureItem>
    </List>
  );
};
